// Adapter for message-bus-client under Rspack.
//
// message-bus-client uses a UMD pattern that relies on AMD `define()` to
// set its module export. Webpack provides `define` in module scope; Rspack
// does not. Without AMD, the library falls to the browser-global branch
// (setting window.MessageBus) but never sets module.exports. This means
// `import Messagebus from 'message-bus-client'` gets an empty object.
//
// This adapter requires the original file (by path, to avoid alias loop),
// then re-exports the global that the UMD IIFE sets.

/* eslint-env node */
require('message-bus-client/assets/message-bus')

module.exports = window.MessageBus
